// // import React, { useState, useEffect } from 'react';
// // import styled from 'styled-components';
// // import { useNavigate } from 'react-router-dom';
// // import { FaCheckCircle, FaExclamationCircle, FaSave, FaSync } from 'react-icons/fa';
// // import NavBarSuper from './NavBarSuper';
// // import Footer from './Footer';
// // import api from '../api';

// // /* ================= HELPERS & CONSTANTS ================= */
// // const DAYS_OF_WEEK = [
// //   { label: 'Sunday', value: 0 },
// //   { label: 'Monday', value: 1 },
// //   { label: 'Tuesday', value: 2 },
// //   { label: 'Wednesday', value: 3 },
// //   { label: 'Thursday', value: 4 },
// //   { label: 'Friday', value: 5 },
// //   { label: 'Saturday', value: 6 },
// // ];

// // const HOURS_OF_DAY = Array.from({ length: 24 }, (_, i) => {
// //   const ampm = i >= 12 ? 'PM' : 'AM';
// //   const hour12 = i % 12 || 12;
// //   return {
// //     label: `${hour12}:00 ${ampm} (${String(i).padStart(2, '0')}:00)`,
// //     value: i
// //   };
// // });

// // /* ================= STYLED COMPONENTS ================= */
// // const AppContainer = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   min-height: 100vh;
// //   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// // `;

// // const PageWrapper = styled.div`
// //   flex: 1 0 auto;
// //   width: min(1200px, calc(100% - 32px));
// //   margin: 90px auto 40px;
// // `;

// // const BackButton = styled.button`
// //   display: inline-flex; align-items: center; gap: 8px; background: none;
// //   border: none; color: #1d4ed8; font-weight: 800; cursor: pointer;
// //   margin-bottom: 20px; transition: transform 0.2s ease;
// //   &:hover { transform: translateX(-4px); }
// // `;

// // const HeroCard = styled.div`
// //   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
// //   color: #fff; border-radius: 24px; padding: 32px; margin-bottom: 32px;
// //   box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
// // `;

// // const HeroTitle = styled.h1`
// //   margin: 0 0 10px; font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem); font-weight: 800;
// // `;

// // const HeroText = styled.p`
// //   margin: 0; color: rgba(255, 255, 255, 0.86); font-size: 1.05rem; max-width: 800px; line-height: 1.5;
// // `;

// // const AlertToast = styled.div`
// //   background: ${props => props.$type === 'error' ? '#fef2f2' : '#f0fdf4'};
// //   border: 1px solid ${props => props.$type === 'error' ? '#fecaca' : '#bbf7d0'};
// //   color: ${props => props.$type === 'error' ? '#991b1b' : '#166534'};
// //   padding: 16px 20px; border-radius: 16px; margin-bottom: 24px;
// //   display: flex; align-items: center; gap: 12px; font-weight: 700;
// //   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
// //   animation: slideIn 0.3s ease;
// //   @keyframes slideIn {
// //     from { opacity: 0; transform: translateY(-10px); }
// //     to { opacity: 1; transform: translateY(0); }
// //   }
// // `;

// // const SectionGrid = styled.div`
// //   display: grid;
// //   grid-template-columns: repeat(2, minmax(0, 1fr));
// //   gap: 24px;
  
// //   @media (max-width: 900px) {
// //     grid-template-columns: 1fr;
// //   }
// // `;

// // const SettingsCard = styled.div`
// //   background: white; border-radius: 20px; padding: 28px;
// //   box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0;
// //   display: flex; flex-direction: column; height: 100%;
// // `;

// // const CardTitle = styled.h2`
// //   margin: 0 0 8px; color: #0f172a; font-size: 1.25rem; font-weight: 800;
// //   display: flex; align-items: center; gap: 10px;
// // `;

// // const CardDesc = styled.p`
// //   margin: 0 0 24px; color: #64748b; font-size: 0.95rem; line-height: 1.5;
// // `;

// // const FormGroup = styled.div`
// //   margin-bottom: 20px;
// // `;

// // const Label = styled.label`
// //   display: block; font-weight: 800; color: #1e293b; font-size: 0.95rem; margin-bottom: 8px;
// // `;

// // const HelperText = styled.div`
// //   font-size: 0.85rem; color: #64748b; margin-top: 6px; line-height: 1.4;
// // `;

// // const Input = styled.input`
// //   width: 100%; padding: 14px 16px; border-radius: 12px; border: 2px solid #e2e8f0;
// //   background: #f8fafc; font-size: 1rem; font-weight: 600; color: #0f172a; outline: none;
// //   transition: all 0.2s;
// //   &:focus { background: white; border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); }
// // `;

// // const Select = styled.select`
// //   width: 100%; padding: 14px 16px; border-radius: 12px; border: 2px solid #e2e8f0;
// //   background: #f8fafc; font-size: 1rem; font-weight: 600; color: #0f172a; outline: none;
// //   cursor: pointer; transition: all 0.2s;
// //   &:focus { background: white; border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); }
// // `;

// // const ActionRow = styled.div`
// //   display: flex; justify-content: flex-end; margin-top: 32px;
// // `;

// // const SaveButton = styled.button`
// //   background: linear-gradient(135deg, #16a34a, #22c55e); color: white;
// //   border: none; padding: 16px 36px; border-radius: 14px; font-weight: 800;
// //   font-size: 1.1rem; cursor: pointer; display: flex; align-items: center; gap: 10px;
// //   box-shadow: 0 10px 25px rgba(22, 163, 74, 0.2); transition: all 0.2s;
// //   &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 15px 30px rgba(22, 163, 74, 0.3); }
// //   &:disabled { background: #94a3b8; cursor: not-allowed; box-shadow: none; transform: none; }
  
// //   @media (max-width: 576px) { width: 100%; justify-content: center; }
// // `;

// // const Row = styled.div`
// //   display: flex; gap: 16px;
// //   > div { flex: 1; }
// //   @media (max-width: 576px) { flex-direction: column; gap: 0; }
// // `;

// // /* ================= MAIN COMPONENT ================= */
// // const ComplianceSettings = ({ user }) => {
// //   const navigate = useNavigate();
// //   const [loading, setLoading] = useState(true);
// //   const [saving, setSaving] = useState(false);
// //   const [alert, setAlert] = useState({ show: false, message: "", type: "success" });

// //   const [settings, setSettings] = useState({
// //     monthlyGoalDeadlineOffset: 0,
// //     weeklyGoalDay: 1,
// //     weeklyGoalHour: 10,
// //     weeklyReportDay: 0,
// //     weeklyReportHour: 23,
// //     appraisalDeadlineOffset: 1,
// //     dailyDeductionAmount: 0.25,
// //     hardCutoffOffset: 2
// //   });

// //   useEffect(() => {
// //     fetchSettings();
// //   }, []);

// //   const triggerAlert = (message, type = "success") => {
// //     setAlert({ show: true, message, type });
// //     setTimeout(() => setAlert({ show: false, message: "", type: "" }), 5000);
// //   };

// //   const fetchSettings = async () => {
// //     try {
// //       setLoading(true);
// //       const res = await api.get('/settings/compliance'); 
// //       if (res.data.success && res.data.data) {
// //         setSettings(res.data.data);
// //       }
// //     } catch (error) {
// //       triggerAlert("Failed to load current settings. Check connection.", "error");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setSettings(prev => ({
// //       ...prev,
// //       [name]: Number(value) // All fields are numbers in the DB schema
// //     }));
// //   };

// //   const handleSave = async () => {
// //     try {
// //       setSaving(true);
// //       await api.put('/settings/compliance', settings);
// //       triggerAlert("Global compliance settings updated successfully.");
// //       window.scrollTo({ top: 0, behavior: 'smooth' });
// //     } catch (error) {
// //       triggerAlert(error.response?.data?.message || "Failed to save settings.", "error");
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <AppContainer>
// //         <NavBarSuper user={user} />
// //         <PageWrapper style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
// //           <FaSync className="fa-spin" size={40} color="#3b82f6" />
// //         </PageWrapper>
// //       </AppContainer>
// //     );
// //   }

// //   return (
// //     <AppContainer>
// //       <NavBarSuper user={user} />
// //       <PageWrapper>
// //         <BackButton onClick={() => navigate('/super-admin/dashboard')}>← Back to Dashboard</BackButton>

// //         <HeroCard>
// //           <HeroTitle>System Compliance Rules</HeroTitle>
// //           <HeroText>
// //             Configure the global deadlines, automated point deductions, and cutoff times for performance appraisals, weekly reports, and goal submissions. These rules affect all staff universally.
// //           </HeroText>
// //         </HeroCard>

// //         {alert.show && (
// //           <AlertToast $type={alert.type}>
// //             {alert.type === 'error' ? <FaExclamationCircle size={20} /> : <FaCheckCircle size={20} />}
// //             {alert.message}
// //           </AlertToast>
// //         )}

// //         <SectionGrid>
// //           {/* --- CARD 1: WEEKLY RHYTHM --- */}
// //           <SettingsCard>
// //             <CardTitle>📅 Weekly Rhythm</CardTitle>
// //             <CardDesc>Set the deadlines for staff to submit their weekly goals and end-of-week achievement reports.</CardDesc>

// //             <Row>
// //               <FormGroup>
// //                 <Label>Weekly Goal Day</Label>
// //                 <Select name="weeklyGoalDay" value={settings.weeklyGoalDay} onChange={handleInputChange}>
// //                   {DAYS_OF_WEEK.map(d => <option key={`wg-d-${d.value}`} value={d.value}>{d.label}</option>)}
// //                 </Select>
// //               </FormGroup>
// //               <FormGroup>
// //                 <Label>Weekly Goal Time</Label>
// //                 <Select name="weeklyGoalHour" value={settings.weeklyGoalHour} onChange={handleInputChange}>
// //                   {HOURS_OF_DAY.map(h => <option key={`wg-h-${h.value}`} value={h.value}>{h.label}</option>)}
// //                 </Select>
// //               </FormGroup>
// //             </Row>
// //             <HelperText style={{marginBottom: 20}}>Example: If Monday at 10:00 AM, goals submitted after this time will be subject to deductions.</HelperText>

// //             <Row>
// //               <FormGroup>
// //                 <Label>Weekly Report Day</Label>
// //                 <Select name="weeklyReportDay" value={settings.weeklyReportDay} onChange={handleInputChange}>
// //                   {DAYS_OF_WEEK.map(d => <option key={`wr-d-${d.value}`} value={d.value}>{d.label}</option>)}
// //                 </Select>
// //               </FormGroup>
// //               <FormGroup>
// //                 <Label>Weekly Report Time</Label>
// //                 <Select name="weeklyReportHour" value={settings.weeklyReportHour} onChange={handleInputChange}>
// //                   {HOURS_OF_DAY.map(h => <option key={`wr-h-${h.value}`} value={h.value}>{h.label}</option>)}
// //                 </Select>
// //               </FormGroup>
// //             </Row>
// //             <HelperText>When staff must report on their week. Usually Sunday at 11:00 PM.</HelperText>
// //           </SettingsCard>

// //           {/* --- CARD 2: MONTHLY & APPRAISAL DEADLINES --- */}
// //           <SettingsCard>
// //             <CardTitle>🗓️ Monthly & Appraisal Deadlines</CardTitle>
// //             <CardDesc>Configure how deadlines map to the end of the current month and the start of the next month.</CardDesc>

// //             <FormGroup>
// //               <Label>Monthly Goal Deadline (Offset)</Label>
// //               <Input 
// //                 type="number" 
// //                 name="monthlyGoalDeadlineOffset" 
// //                 value={settings.monthlyGoalDeadlineOffset} 
// //                 onChange={handleInputChange} 
// //               />
// //               <HelperText>
// //                 Days offset from the end of the target month. <br/>
// //                 <strong>0</strong> = The exact last day of the month.<br/>
// //                 <strong>-1</strong> = The second to last day of the month.
// //               </HelperText>
// //             </FormGroup>

// //             <FormGroup>
// //               <Label>Appraisal Form Deadline (Offset)</Label>
// //               <Input 
// //                 type="number" 
// //                 name="appraisalDeadlineOffset" 
// //                 value={settings.appraisalDeadlineOffset} 
// //                 onChange={handleInputChange} 
// //               />
// //               <HelperText>
// //                 Days into the <em>next</em> month before the form is considered late.<br/>
// //                 <strong>1</strong> = The 1st day of the next month.<br/>
// //                 <strong>2</strong> = The 2nd day of the next month.
// //               </HelperText>
// //             </FormGroup>
// //           </SettingsCard>

// //           {/* --- CARD 3: PENALTIES & CUTOFFS --- */}
// //           <SettingsCard style={{ gridColumn: '1 / -1' }}>
// //             <CardTitle>⚠️ Penalties & Hard Cutoffs</CardTitle>
// //             <CardDesc>Determine how points are lost when staff miss the deadlines configured above.</CardDesc>

// //             <SectionGrid>
// //               <FormGroup>
// //                 <Label>Daily Point Deduction</Label>
// //                 <Input 
// //                   type="number" 
// //                   step="0.05"
// //                   min="0"
// //                   name="dailyDeductionAmount" 
// //                   value={settings.dailyDeductionAmount} 
// //                   onChange={handleInputChange} 
// //                 />
// //                 <HelperText>
// //                   The exact number of points deducted from a perfect compliance score (5.0) for <strong>every full 24 hours</strong> a submission is late. <br/>
// //                   <em>Default is 0.25 points per day.</em>
// //                 </HelperText>
// //               </FormGroup>

// //               <FormGroup>
// //                 <Label>Absolute Zero / Hard Cutoff (Offset)</Label>
// //                 <Input 
// //                   type="number" 
// //                   name="hardCutoffOffset" 
// //                   value={settings.hardCutoffOffset} 
// //                   onChange={handleInputChange} 
// //                 />
// //                 <HelperText>
// //                   Days into the next month where the system will automatically award a <strong>score of 0</strong> regardless of submission.<br/>
// //                   <strong>2</strong> = If submitted on or after the 2nd day of the next month, the score instantly becomes 0.
// //                 </HelperText>
// //               </FormGroup>
// //             </SectionGrid>
// //           </SettingsCard>
// //         </SectionGrid>

// //         <ActionRow>
// //           <SaveButton onClick={handleSave} disabled={saving}>
// //             {saving ? <FaSync className="fa-spin" /> : <FaSave />}
// //             {saving ? "Saving Configuration..." : "Save Global Compliance Rules"}
// //           </SaveButton>
// //         </ActionRow>

// //       </PageWrapper>
// //       <Footer />
// //     </AppContainer>
// //   );
// // };

// // export default ComplianceSettings;



// // import React, { useState, useEffect } from 'react';
// // import styled from 'styled-components';
// // import { useNavigate } from 'react-router-dom';
// // import { FaCheckCircle, FaExclamationCircle, FaSave, FaSync, FaInfoCircle } from 'react-icons/fa';
// // import NavBarSuper from './NavBarSuper';
// // import Footer from './Footer';
// // import api from '../api';

// // /* ================= HELPERS & CONSTANTS ================= */
// // const DAYS_OF_WEEK = [
// //   { label: 'Sunday', value: 0 },
// //   { label: 'Monday', value: 1 },
// //   { label: 'Tuesday', value: 2 },
// //   { label: 'Wednesday', value: 3 },
// //   { label: 'Thursday', value: 4 },
// //   { label: 'Friday', value: 5 },
// //   { label: 'Saturday', value: 6 },
// // ];

// // const MONTHLY_RULES = [
// //   { label: '3 Days Before the Month Ends (11:59 PM)', value: -3 },
// //   { label: '2 Days Before the Month Ends (11:59 PM)', value: -2 },
// //   { label: '1 Day Before the Month Ends (11:59 PM)', value: -1 },
// //   { label: 'The Exact Last Day of the Month (11:59 PM)', value: 0 },
// //   { label: '1st Day of the NEXT Month (11:59 PM)', value: 1 },
// //   { label: '2nd Day of the NEXT Month (11:59 PM)', value: 2 },
// //   { label: '3rd Day of the NEXT Month (11:59 PM)', value: 3 },
// // ];

// // const CUTOFF_RULES = [
// //   { label: '1st Day of the NEXT Month at Midnight', value: 1 },
// //   { label: '2nd Day of the NEXT Month at Midnight', value: 2 },
// //   { label: '3rd Day of the NEXT Month at Midnight', value: 3 },
// //   { label: '4th Day of the NEXT Month at Midnight', value: 4 },
// //   { label: '5th Day of the NEXT Month at Midnight', value: 5 },
// // ];

// // /* ================= STYLED COMPONENTS ================= */
// // const AppContainer = styled.div`
// //   display: flex; flex-direction: column; min-height: 100vh;
// //   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// // `;

// // const PageWrapper = styled.div`
// //   flex: 1 0 auto; width: min(1200px, calc(100% - 32px)); margin: 90px auto 40px;
// // `;

// // const BackButton = styled.button`
// //   display: inline-flex; align-items: center; gap: 8px; background: none;
// //   border: none; color: #1d4ed8; font-weight: 800; cursor: pointer;
// //   margin-bottom: 20px; transition: transform 0.2s ease;
// //   &:hover { transform: translateX(-4px); }
// // `;

// // const HeroCard = styled.div`
// //   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
// //   color: #fff; border-radius: 24px; padding: 32px; margin-bottom: 32px;
// //   box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
// // `;

// // const HeroTitle = styled.h1`
// //   margin: 0 0 10px; font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem); font-weight: 800;
// // `;

// // const HeroText = styled.p`
// //   margin: 0; color: rgba(255, 255, 255, 0.86); font-size: 1.05rem; max-width: 800px; line-height: 1.5;
// // `;

// // const AlertToast = styled.div`
// //   background: ${props => props.$type === 'error' ? '#fef2f2' : '#f0fdf4'};
// //   border: 1px solid ${props => props.$type === 'error' ? '#fecaca' : '#bbf7d0'};
// //   color: ${props => props.$type === 'error' ? '#991b1b' : '#166534'};
// //   padding: 16px 20px; border-radius: 16px; margin-bottom: 24px;
// //   display: flex; align-items: center; gap: 12px; font-weight: 700;
// //   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
// // `;

// // const InfoBox = styled.div`
// //   background: #eff6ff; border-left: 4px solid #3b82f6; padding: 16px;
// //   border-radius: 8px; margin-bottom: 24px; display: flex; gap: 12px;
// //   color: #1e3a8a; font-size: 0.95rem; line-height: 1.5;
// // `;

// // const SectionGrid = styled.div`
// //   display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px;
// //   @media (max-width: 900px) { grid-template-columns: 1fr; }
// // `;

// // const SettingsCard = styled.div`
// //   background: white; border-radius: 20px; padding: 28px;
// //   box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0;
// //   display: flex; flex-direction: column; height: 100%;
// // `;

// // const CardTitle = styled.h2`
// //   margin: 0 0 8px; color: #0f172a; font-size: 1.25rem; font-weight: 800;
// //   display: flex; align-items: center; gap: 10px;
// // `;

// // const CardDesc = styled.p`
// //   margin: 0 0 24px; color: #64748b; font-size: 0.95rem; line-height: 1.5;
// // `;

// // const FormGroup = styled.div`
// //   margin-bottom: 20px;
// // `;

// // const Label = styled.label`
// //   display: block; font-weight: 800; color: #1e293b; font-size: 0.95rem; margin-bottom: 8px;
// // `;

// // const HelperText = styled.div`
// //   font-size: 0.85rem; color: #64748b; margin-top: 6px; line-height: 1.4;
// // `;

// // const Input = styled.input`
// //   width: 100%; padding: 14px 16px; border-radius: 12px; border: 2px solid #e2e8f0;
// //   background: #f8fafc; font-size: 1rem; font-weight: 600; color: #0f172a; outline: none;
// //   cursor: pointer;
// //   &:focus { background: white; border-color: #3b82f6; }
  
// //   /* Make the time picker clock icon larger */
// //   &::-webkit-calendar-picker-indicator { cursor: pointer; font-size: 1.2rem; }
// // `;

// // const Select = styled.select`
// //   width: 100%; padding: 14px 16px; border-radius: 12px; border: 2px solid #e2e8f0;
// //   background: #f8fafc; font-size: 1rem; font-weight: 600; color: #0f172a; outline: none; cursor: pointer;
// //   &:focus { background: white; border-color: #3b82f6; }
// // `;

// // const SaveButton = styled.button`
// //   background: linear-gradient(135deg, #16a34a, #22c55e); color: white;
// //   border: none; padding: 16px 36px; border-radius: 14px; font-weight: 800;
// //   font-size: 1.1rem; cursor: pointer; display: flex; align-items: center; gap: 10px;
// //   margin-top: 32px; float: right;
// //   &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 15px 30px rgba(22, 163, 74, 0.3); }
// // `;

// // const Row = styled.div`
// //   display: flex; gap: 16px;
// //   > div { flex: 1; }
// //   @media (max-width: 576px) { flex-direction: column; gap: 0; }
// // `;

// // /* ================= MAIN COMPONENT ================= */
// // const ComplianceSettings = ({ user }) => {
// //   const navigate = useNavigate();
// //   const [loading, setLoading] = useState(true);
// //   const [saving, setSaving] = useState(false);
// //   const [alert, setAlert] = useState({ show: false, message: "", type: "success" });

// //   const [settings, setSettings] = useState({
// //     monthlyGoalDeadlineOffset: 0,
// //     weeklyGoalDay: 1,
// //     weeklyGoalTime: "10:00",  // Frontend specific clock state
// //     weeklyReportDay: 0,
// //     weeklyReportTime: "23:59", // Frontend specific clock state
// //     appraisalDeadlineOffset: 1,
// //     dailyDeductionAmount: 0.25,
// //     hardCutoffOffset: 2
// //   });

// //   useEffect(() => {
// //     fetchSettings();
// //   }, []);

// //   const triggerAlert = (message, type = "success") => {
// //     setAlert({ show: true, message, type });
// //     setTimeout(() => setAlert({ show: false, message: "", type: "" }), 5000);
// //   };

// //   const fetchSettings = async () => {
// //     try {
// //       setLoading(true);
// //       const res = await api.get('/settings/compliance'); 
// //       if (res.data.success && res.data.data) {
// //         const dbData = res.data.data;
        
// //         // Convert the backend's raw "Hour" numbers into nice "HH:MM" format for the time picker
// //         const wGoalTime = `${String(dbData.weeklyGoalHour).padStart(2, '0')}:00`;
// //         const wRepTime = `${String(dbData.weeklyReportHour).padStart(2, '0')}:59`;

// //         setSettings({
// //           ...dbData,
// //           weeklyGoalTime: wGoalTime,
// //           weeklyReportTime: wRepTime
// //         });
// //       }
// //     } catch (error) {
// //       triggerAlert("Failed to load settings. Check connection.", "error");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleInputChange = (e) => {
// //     const { name, value, type } = e.target;
// //     setSettings(prev => ({
// //       ...prev,
// //       [name]: type === 'time' ? value : Number(value)
// //     }));
// //   };

// //   const handleSave = async () => {
// //     try {
// //       setSaving(true);
      
// //       // Convert the frontend "HH:MM" clock times back into the raw Hours the backend expects
// //       const payload = {
// //         monthlyGoalDeadlineOffset: settings.monthlyGoalDeadlineOffset,
// //         weeklyGoalDay: settings.weeklyGoalDay,
// //         weeklyGoalHour: parseInt(settings.weeklyGoalTime.split(':')[0], 10), // Extacts '10' from '10:00'
// //         weeklyReportDay: settings.weeklyReportDay,
// //         weeklyReportHour: parseInt(settings.weeklyReportTime.split(':')[0], 10), // Extracts '23' from '23:59'
// //         appraisalDeadlineOffset: settings.appraisalDeadlineOffset,
// //         dailyDeductionAmount: settings.dailyDeductionAmount,
// //         hardCutoffOffset: settings.hardCutoffOffset
// //       };

// //       await api.put('/settings/compliance', payload);
// //       triggerAlert("Global compliance settings updated successfully.");
// //       window.scrollTo({ top: 0, behavior: 'smooth' });
// //     } catch (error) {
// //       triggerAlert(error.response?.data?.message || "Failed to save settings.", "error");
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   if (loading) return <AppContainer><PageWrapper><FaSync className="fa-spin" size={40} color="#3b82f6" /></PageWrapper></AppContainer>;

// //   return (
// //     <AppContainer>
// //       <NavBarSuper user={user} />
// //       <PageWrapper>
// //         <BackButton onClick={() => navigate('/super-admin/dashboard')}>← Back to Dashboard</BackButton>

// //         <HeroCard>
// //           <HeroTitle>System Compliance Rules</HeroTitle>
// //           <HeroText>
// //             Set the official system deadlines. These rules automatically update the calendar every month so you never have to change them manually.
// //           </HeroText>
// //         </HeroCard>

// //         {alert.show && (
// //           <AlertToast $type={alert.type}>
// //             {alert.type === 'error' ? <FaExclamationCircle size={20} /> : <FaCheckCircle size={20} />}
// //             {alert.message}
// //           </AlertToast>
// //         )}

// //         <InfoBox>
// //           <FaInfoCircle size={24} style={{ flexShrink: 0, marginTop: 2 }} />
// //           <div>
// //             <strong>Why don't we use a standard Calendar?</strong><br />
// //             If you picked "May 31st" from a calendar, you would have to log in and change it to "June 30th" next month. By selecting <em>"The Exact Last Day of the Month"</em>, the system automatically adapts to months with 28, 30, or 31 days forever.
// //           </div>
// //         </InfoBox>

// //         <SectionGrid>
// //           {/* --- WEEKLY DEADLINES --- */}
// //           <SettingsCard>
// //             <CardTitle>📅 Weekly Rhythm (Clock)</CardTitle>
// //             <CardDesc>Choose the day and exact time staff must submit their weekly tasks.</CardDesc>

// //             <Row>
// //               <FormGroup>
// //                 <Label>Weekly Goal Deadline</Label>
// //                 <Select name="weeklyGoalDay" value={settings.weeklyGoalDay} onChange={handleInputChange}>
// //                   {DAYS_OF_WEEK.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
// //                 </Select>
// //               </FormGroup>
// //               <FormGroup>
// //                 <Label>Goal Time</Label>
// //                 <Input type="time" name="weeklyGoalTime" value={settings.weeklyGoalTime} onChange={handleInputChange} />
// //               </FormGroup>
// //             </Row>

// //             <Row>
// //               <FormGroup>
// //                 <Label>Weekly Report Deadline</Label>
// //                 <Select name="weeklyReportDay" value={settings.weeklyReportDay} onChange={handleInputChange}>
// //                   {DAYS_OF_WEEK.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
// //                 </Select>
// //               </FormGroup>
// //               <FormGroup>
// //                 <Label>Report Time</Label>
// //                 <Input type="time" name="weeklyReportTime" value={settings.weeklyReportTime} onChange={handleInputChange} />
// //               </FormGroup>
// //             </Row>
// //           </SettingsCard>

// //           {/* --- MONTHLY DEADLINES --- */}
// //           <SettingsCard>
// //             <CardTitle>🗓️ Monthly & Appraisal Deadlines</CardTitle>
// //             <CardDesc>Select when the major monthly submissions are due.</CardDesc>

// //             <FormGroup>
// //               <Label>When are Monthly Goals due?</Label>
// //               <Select name="monthlyGoalDeadlineOffset" value={settings.monthlyGoalDeadlineOffset} onChange={handleInputChange}>
// //                 {MONTHLY_RULES.map(rule => <option key={rule.value} value={rule.value}>{rule.label}</option>)}
// //               </Select>
// //             </FormGroup>

// //             <FormGroup>
// //               <Label>When is the Appraisal Form due?</Label>
// //               <Select name="appraisalDeadlineOffset" value={settings.appraisalDeadlineOffset} onChange={handleInputChange}>
// //                 {MONTHLY_RULES.map(rule => <option key={rule.value} value={rule.value}>{rule.label}</option>)}
// //               </Select>
// //             </FormGroup>
// //           </SettingsCard>

// //           {/* --- PENALTIES & CUTOFFS --- */}
// //           <SettingsCard style={{ gridColumn: '1 / -1' }}>
// //             <CardTitle>⚠️ Penalties & Hard Cutoffs</CardTitle>
// //             <CardDesc>If staff miss the exact times set above, how should the system penalize them?</CardDesc>

// //             <SectionGrid>
// //               <FormGroup>
// //                 <Label>Daily Point Deduction (Score out of 5.0)</Label>
// //                 <Input 
// //                   type="number" step="0.05" min="0" max="5"
// //                   name="dailyDeductionAmount" 
// //                   value={settings.dailyDeductionAmount} 
// //                   onChange={handleInputChange} 
// //                 />
// //                 <HelperText>
// //                   The exact points subtracted for every 24 hours a submission is late. Example: <strong>0.25</strong>.
// //                 </HelperText>
// //               </FormGroup>

// //               <FormGroup>
// //                 <Label>Absolute Zero / Hard Cutoff Date</Label>
// //                 <Select name="hardCutoffOffset" value={settings.hardCutoffOffset} onChange={handleInputChange}>
// //                   {CUTOFF_RULES.map(rule => <option key={rule.value} value={rule.value}>{rule.label}</option>)}
// //                 </Select>
// //                 <HelperText>
// //                   Any submission made on or after this date automatically receives a <strong>0.0</strong> score, regardless of the daily deduction.
// //                 </HelperText>
// //               </FormGroup>
// //             </SectionGrid>
// //           </SettingsCard>
// //         </SectionGrid>

// //         <div style={{ clear: 'both' }}>
// //           <SaveButton onClick={handleSave} disabled={saving}>
// //             {saving ? <FaSync className="fa-spin" /> : <FaSave />}
// //             {saving ? "Saving..." : "Save Global Compliance Rules"}
// //           </SaveButton>
// //         </div>

// //       </PageWrapper>
// //       <Footer />
// //     </AppContainer>
// //   );
// // };

// // export default ComplianceSettings;




// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import { FaCheckCircle, FaExclamationCircle, FaSave, FaSync, FaInfoCircle } from 'react-icons/fa';
// import NavBarSuper from './NavBarSuper';
// import Footer from './Footer';
// import api from '../api';

// /* ================= HELPERS & CONSTANTS ================= */
// const DAYS_OF_WEEK = [
//   { label: 'Sunday', value: 0 },
//   { label: 'Monday', value: 1 },
//   { label: 'Tuesday', value: 2 },
//   { label: 'Wednesday', value: 3 },
//   { label: 'Thursday', value: 4 },
//   { label: 'Friday', value: 5 },
//   { label: 'Saturday', value: 6 },
// ];

// const MONTHLY_RULES = [
//   { label: '3 Days Before the Month Ends (11:59 PM)', value: -3 },
//   { label: '2 Days Before the Month Ends (11:59 PM)', value: -2 },
//   { label: '1 Day Before the Month Ends (11:59 PM)', value: -1 },
//   { label: 'The Exact Last Day of the Month (11:59 PM)', value: 0 },
//   { label: '1st Day of the NEXT Month (11:59 PM)', value: 1 },
//   { label: '2nd Day of the NEXT Month (11:59 PM)', value: 2 },
//   { label: '3rd Day of the NEXT Month (11:59 PM)', value: 3 },
// ];

// /* ================= STYLED COMPONENTS ================= */
// const AppContainer = styled.div`
//   display: flex; flex-direction: column; min-height: 100vh;
//   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// `;

// const PageWrapper = styled.div`
//   flex: 1 0 auto; width: min(1200px, calc(100% - 32px)); margin: 90px auto 40px;
// `;

// const BackButton = styled.button`
//   display: inline-flex; align-items: center; gap: 8px; background: none;
//   border: none; color: #1d4ed8; font-weight: 800; cursor: pointer;
//   margin-bottom: 20px; transition: transform 0.2s ease;
//   &:hover { transform: translateX(-4px); }
// `;

// const HeroCard = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
//   color: #fff; border-radius: 24px; padding: 32px; margin-bottom: 32px;
//   box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
// `;

// const HeroTitle = styled.h1`
//   margin: 0 0 10px; font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem); font-weight: 800;
// `;

// const HeroText = styled.p`
//   margin: 0; color: rgba(255, 255, 255, 0.86); font-size: 1.05rem; max-width: 800px; line-height: 1.5;
// `;

// const AlertToast = styled.div`
//   background: ${props => props.$type === 'error' ? '#fef2f2' : '#f0fdf4'};
//   border: 1px solid ${props => props.$type === 'error' ? '#fecaca' : '#bbf7d0'};
//   color: ${props => props.$type === 'error' ? '#991b1b' : '#166534'};
//   padding: 16px 20px; border-radius: 16px; margin-bottom: 24px;
//   display: flex; align-items: center; gap: 12px; font-weight: 700;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
// `;

// const InfoBox = styled.div`
//   background: #eff6ff; border-left: 4px solid #3b82f6; padding: 16px;
//   border-radius: 8px; margin-bottom: 24px; display: flex; gap: 12px;
//   color: #1e3a8a; font-size: 0.95rem; line-height: 1.5;
// `;

// const SectionGrid = styled.div`
//   display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px;
//   @media (max-width: 900px) { grid-template-columns: 1fr; }
// `;

// const SettingsCard = styled.div`
//   background: white; border-radius: 20px; padding: 28px;
//   box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0;
//   display: flex; flex-direction: column; height: 100%;
// `;

// const CardTitle = styled.h2`
//   margin: 0 0 8px; color: #0f172a; font-size: 1.25rem; font-weight: 800;
//   display: flex; align-items: center; gap: 10px;
// `;

// const CardDesc = styled.p`
//   margin: 0 0 24px; color: #64748b; font-size: 0.95rem; line-height: 1.5;
// `;

// const FormGroup = styled.div`
//   margin-bottom: 20px;
// `;

// const Label = styled.label`
//   display: block; font-weight: 800; color: #1e293b; font-size: 0.95rem; margin-bottom: 8px;
// `;

// const HelperText = styled.div`
//   font-size: 0.85rem; color: #64748b; margin-top: 6px; line-height: 1.4;
// `;

// const Input = styled.input`
//   width: 100%; padding: 14px 16px; border-radius: 12px; border: 2px solid #e2e8f0;
//   background: #f8fafc; font-size: 1rem; font-weight: 600; color: #0f172a; outline: none;
//   cursor: pointer;
//   &:focus { background: white; border-color: #3b82f6; }
  
//   /* Make the time picker clock icon larger */
//   &::-webkit-calendar-picker-indicator { cursor: pointer; font-size: 1.2rem; }
// `;

// const Select = styled.select`
//   width: 100%; padding: 14px 16px; border-radius: 12px; border: 2px solid #e2e8f0;
//   background: #f8fafc; font-size: 1rem; font-weight: 600; color: #0f172a; outline: none; cursor: pointer;
//   &:focus { background: white; border-color: #3b82f6; }
// `;

// const SaveButton = styled.button`
//   background: linear-gradient(135deg, #16a34a, #22c55e); color: white;
//   border: none; padding: 16px 36px; border-radius: 14px; font-weight: 800;
//   font-size: 1.1rem; cursor: pointer; display: flex; align-items: center; gap: 10px;
//   margin-top: 32px; float: right;
//   &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 15px 30px rgba(22, 163, 74, 0.3); }
// `;

// const Row = styled.div`
//   display: flex; gap: 16px;
//   > div { flex: 1; }
//   @media (max-width: 576px) { flex-direction: column; gap: 0; }
// `;

// /* ================= MAIN COMPONENT ================= */
// const ComplianceSettings = ({ user }) => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [alert, setAlert] = useState({ show: false, message: "", type: "success" });

//   const [settings, setSettings] = useState({
//     monthlyGoalDeadlineOffset: 0,
//     weeklyGoalDay: 1,
//     weeklyGoalTime: "10:00", 
//     weeklyReportDay: 0,
//     weeklyReportTime: "23:59", 
//     appraisalDeadlineOffset: 1,
//     dailyDeductionAmount: 0.25
//     // 🔥 REMOVED hardCutoffOffset from state
//   });

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   const triggerAlert = (message, type = "success") => {
//     setAlert({ show: true, message, type });
//     setTimeout(() => setAlert({ show: false, message: "", type: "" }), 5000);
//   };

//   const fetchSettings = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get('/settings/compliance'); 
//       if (res.data.success && res.data.data) {
//         const dbData = res.data.data;
        
//         // Convert the backend's raw "Hour" numbers into nice "HH:MM" format for the time picker
//         const wGoalTime = `${String(dbData.weeklyGoalHour || 10).padStart(2, '0')}:00`;
//         const wRepTime = `${String(dbData.weeklyReportHour || 23).padStart(2, '0')}:59`;

//         setSettings({
//           monthlyGoalDeadlineOffset: dbData.monthlyGoalDeadlineOffset ?? 0,
//           weeklyGoalDay: dbData.weeklyGoalDay ?? 1,
//           weeklyGoalTime: wGoalTime,
//           weeklyReportDay: dbData.weeklyReportDay ?? 0,
//           weeklyReportTime: wRepTime,
//           appraisalDeadlineOffset: dbData.appraisalDeadlineOffset ?? 1,
//           dailyDeductionAmount: dbData.dailyDeductionAmount ?? 0.25,
//         });
//       }
//     } catch (error) {
//       triggerAlert("Failed to load settings. Check connection.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type } = e.target;
//     setSettings(prev => ({
//       ...prev,
//       [name]: type === 'time' ? value : Number(value)
//     }));
//   };

//   const handleSave = async () => {
//     try {
//       setSaving(true);
      
//       // Convert the frontend "HH:MM" clock times back into the raw Hours the backend expects
//       const payload = {
//         monthlyGoalDeadlineOffset: settings.monthlyGoalDeadlineOffset,
//         weeklyGoalDay: settings.weeklyGoalDay,
//         weeklyGoalHour: parseInt(settings.weeklyGoalTime.split(':')[0], 10), // Extacts '10' from '10:00'
//         weeklyReportDay: settings.weeklyReportDay,
//         weeklyReportHour: parseInt(settings.weeklyReportTime.split(':')[0], 10), // Extracts '23' from '23:59'
//         appraisalDeadlineOffset: settings.appraisalDeadlineOffset,
//         dailyDeductionAmount: settings.dailyDeductionAmount
//         // 🔥 REMOVED hardCutoffOffset from payload
//       };

//       await api.put('/settings/compliance', payload);
//       triggerAlert("Global compliance settings updated successfully.");
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (error) {
//       triggerAlert(error.response?.data?.message || "Failed to save settings.", "error");
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) return <AppContainer><PageWrapper><FaSync className="fa-spin" size={40} color="#3b82f6" /></PageWrapper></AppContainer>;

//   return (
//     <AppContainer>
//       <NavBarSuper user={user} />
//       <PageWrapper>
//         <BackButton onClick={() => navigate('/super-admin/dashboard')}>← Back to Dashboard</BackButton>

//         <HeroCard>
//           <HeroTitle>System Compliance Rules</HeroTitle>
//           <HeroText>
//             Set the official system deadlines. These rules automatically update the calendar every month so you never have to change them manually.
//           </HeroText>
//         </HeroCard>

//         {alert.show && (
//           <AlertToast $type={alert.type}>
//             {alert.type === 'error' ? <FaExclamationCircle size={20} /> : <FaCheckCircle size={20} />}
//             {alert.message}
//           </AlertToast>
//         )}

//         <InfoBox>
//           <FaInfoCircle size={24} style={{ flexShrink: 0, marginTop: 2 }} />
//           <div>
//             <strong>Why don't we use a standard Calendar?</strong><br />
//             If you picked "May 31st" from a calendar, you would have to log in and change it to "June 30th" next month. By selecting <em>"The Exact Last Day of the Month"</em>, the system automatically adapts to months with 28, 30, or 31 days forever.
//           </div>
//         </InfoBox>

//         <SectionGrid>
//           {/* --- WEEKLY DEADLINES --- */}
//           <SettingsCard>
//             <CardTitle>📅 Weekly Rhythm (Clock)</CardTitle>
//             <CardDesc>Choose the day and exact time staff must submit their weekly tasks.</CardDesc>

//             <Row>
//               <FormGroup>
//                 <Label>Weekly Goal Deadline</Label>
//                 <Select name="weeklyGoalDay" value={settings.weeklyGoalDay} onChange={handleInputChange}>
//                   {DAYS_OF_WEEK.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
//                 </Select>
//               </FormGroup>
//               <FormGroup>
//                 <Label>Goal Time</Label>
//                 <Input type="time" name="weeklyGoalTime" value={settings.weeklyGoalTime} onChange={handleInputChange} />
//               </FormGroup>
//             </Row>

//             <Row>
//               <FormGroup>
//                 <Label>Weekly Report Deadline</Label>
//                 <Select name="weeklyReportDay" value={settings.weeklyReportDay} onChange={handleInputChange}>
//                   {DAYS_OF_WEEK.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
//                 </Select>
//               </FormGroup>
//               <FormGroup>
//                 <Label>Report Time</Label>
//                 <Input type="time" name="weeklyReportTime" value={settings.weeklyReportTime} onChange={handleInputChange} />
//               </FormGroup>
//             </Row>
//           </SettingsCard>

//           {/* --- MONTHLY DEADLINES --- */}
//           <SettingsCard>
//             <CardTitle>🗓️ Monthly & Appraisal Deadlines</CardTitle>
//             <CardDesc>Select when the major monthly submissions are due.</CardDesc>

//             <FormGroup>
//               <Label>When are Monthly Goals due?</Label>
//               <Select name="monthlyGoalDeadlineOffset" value={settings.monthlyGoalDeadlineOffset} onChange={handleInputChange}>
//                 {MONTHLY_RULES.map(rule => <option key={rule.value} value={rule.value}>{rule.label}</option>)}
//               </Select>
//             </FormGroup>

//             <FormGroup>
//               <Label>When is the Appraisal Form due?</Label>
//               <Select name="appraisalDeadlineOffset" value={settings.appraisalDeadlineOffset} onChange={handleInputChange}>
//                 {MONTHLY_RULES.map(rule => <option key={rule.value} value={rule.value}>{rule.label}</option>)}
//               </Select>
//             </FormGroup>
//           </SettingsCard>

//           {/* --- PENALTIES & CUTOFFS --- */}
//           <SettingsCard style={{ gridColumn: '1 / -1' }}>
//             <CardTitle>⚠️ Infinite Penalties</CardTitle>
//             <CardDesc>If staff miss the exact times set above, how should the system penalize them?</CardDesc>

//             <SectionGrid>
//               <FormGroup>
//                 <Label>Daily Point Deduction (Score out of 5.0)</Label>
//                 <Input 
//                   type="number" step="0.05" min="0" max="5"
//                   name="dailyDeductionAmount" 
//                   value={settings.dailyDeductionAmount} 
//                   onChange={handleInputChange} 
//                 />
//                 <HelperText>
//                   The exact points subtracted for every 24 hours a submission is late. Example: <strong>0.25</strong>.<br/><br/>
//                   <strong style={{color: '#dc2626'}}>Note:</strong> Deductions are infinite. If a user never logs an achievement for a goal, their score will continue dropping into negative numbers every single day until the end of time.
//                 </HelperText>
//               </FormGroup>
//             </SectionGrid>
//           </SettingsCard>
//         </SectionGrid>

//         <div style={{ clear: 'both' }}>
//           <SaveButton onClick={handleSave} disabled={saving}>
//             {saving ? <FaSync className="fa-spin" /> : <FaSave />}
//             {saving ? "Saving..." : "Save Global Compliance Rules"}
//           </SaveButton>
//         </div>

//       </PageWrapper>
//       <Footer />
//     </AppContainer>
//   );
// };

// export default ComplianceSettings;

///api/settings/compliance

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaExclamationCircle, FaSave, FaSync, FaInfoCircle, FaTimes } from 'react-icons/fa';
import NavBarSuper from './NavBarSuper';
import Footer from './Footer';
import api from '../api';

/* ================= HELPERS & CONSTANTS ================= */
const DAYS_OF_WEEK = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
];

const MONTHLY_RULES = [
  { label: '3 Days Before the Month Ends (11:59 PM)', value: -3 },
  { label: '2 Days Before the Month Ends (11:59 PM)', value: -2 },
  { label: '1 Day Before the Month Ends (11:59 PM)', value: -1 },
  { label: 'The Exact Last Day of the Month (11:59 PM)', value: 0 },
  { label: '1st Day of the NEXT Month (11:59 PM)', value: 1 },
  { label: '2nd Day of the NEXT Month (11:59 PM)', value: 2 },
  { label: '3rd Day of the NEXT Month (11:59 PM)', value: 3 },
];

const getCurrentMonthName = () => {
  const date = new Date();
  return date.toLocaleString("default", { month: "long", year: "numeric" });
};

const generateMonthOptions = () => {
  const months = [];
  const date = new Date();
  date.setMonth(date.getMonth() - 3); 
  for (let i = 0; i < 12; i++) {
    months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
    date.setMonth(date.getMonth() + 1);
  }
  return months;
};

// 🔥 GENERATE WEEK LABELS FOR SELECTED MONTH 🔥
const generateWeekLabels = (periodString) => {
  const defaultLabels = ["Wk 1", "Wk 2", "Wk 3", "Wk 4", "Wk 5"];
  if (!periodString) return defaultLabels;
  const d = new Date(periodString);
  if (isNaN(d.getTime())) return defaultLabels;
  
  const y = d.getFullYear();
  const m = d.getMonth();
  const lastDay = new Date(y, m + 1, 0); 
  
  const labels = ["Wk 1", "Wk 2", "Wk 3", "Wk 4"];
  if (lastDay.getDay() !== 6) { 
    const nextMonth = new Date(y, m + 1, 1).toLocaleString('default', { month: 'short' });
    labels.push(`Wk 5 / ${nextMonth} Wk 1`);
  } else {
    labels.push("Wk 5");
  }
  return labels;
};

/* ================= STYLED COMPONENTS ================= */
const AppContainer = styled.div`
  display: flex; flex-direction: column; min-height: 100vh;
  background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
`;

const PageWrapper = styled.div`
  flex: 1 0 auto; width: min(1200px, calc(100% - 32px)); margin: 90px auto 40px;
`;

const BackButton = styled.button`
  display: inline-flex; align-items: center; gap: 8px; background: none;
  border: none; color: #1d4ed8; font-weight: 800; cursor: pointer;
  margin-bottom: 20px; transition: transform 0.2s ease;
  &:hover { transform: translateX(-4px); }
`;

const HeroCard = styled.div`
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
  color: #fff; border-radius: 24px; padding: 32px; margin-bottom: 32px;
  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
`;

const HeroTitle = styled.h1`
  margin: 0 0 10px; font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem); font-weight: 800;
`;

const HeroText = styled.p`
  margin: 0; color: rgba(255, 255, 255, 0.86); font-size: 1.05rem; max-width: 800px; line-height: 1.5;
`;

const AlertToast = styled.div`
  background: ${props => props.$type === 'error' ? '#fef2f2' : '#f0fdf4'};
  border: 1px solid ${props => props.$type === 'error' ? '#fecaca' : '#bbf7d0'};
  color: ${props => props.$type === 'error' ? '#991b1b' : '#166534'};
  padding: 16px 20px; border-radius: 16px; margin-bottom: 24px;
  display: flex; align-items: center; gap: 12px; font-weight: 700;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const InfoBox = styled.div`
  background: #eff6ff; border-left: 4px solid #3b82f6; padding: 16px;
  border-radius: 8px; margin-bottom: 24px; display: flex; gap: 12px;
  color: #1e3a8a; font-size: 0.95rem; line-height: 1.5;
`;

const SectionGrid = styled.div`
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

const SettingsCard = styled.div`
  background: white; border-radius: 20px; padding: 28px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0;
  display: flex; flex-direction: column; height: 100%;
`;

const CardTitle = styled.h2`
  margin: 0 0 8px; color: #0f172a; font-size: 1.25rem; font-weight: 800;
  display: flex; align-items: center; gap: 10px;
`;

const CardDesc = styled.p`
  margin: 0 0 24px; color: #64748b; font-size: 0.95rem; line-height: 1.5;
`;

const FormGroup = styled.div` margin-bottom: 20px; `;
const Label = styled.label` display: block; font-weight: 800; color: #1e293b; font-size: 0.95rem; margin-bottom: 8px; `;
const HelperText = styled.div` font-size: 0.85rem; color: #64748b; margin-top: 6px; line-height: 1.4; `;

const Input = styled.input`
  width: 100%; padding: 14px 16px; border-radius: 12px; border: 2px solid #e2e8f0;
  background: #f8fafc; font-size: 1rem; font-weight: 600; color: #0f172a; outline: none; cursor: pointer;
  box-sizing: border-box;
  &:focus { background: white; border-color: #3b82f6; }
`;

const Select = styled.select`
  width: 100%; padding: 14px 16px; border-radius: 12px; border: 2px solid #e2e8f0;
  background: #f8fafc; font-size: 1rem; font-weight: 600; color: #0f172a; outline: none; cursor: pointer;
  box-sizing: border-box;
  &:focus { background: white; border-color: #3b82f6; }
`;

const SaveButton = styled.button`
  background: linear-gradient(135deg, #16a34a, #22c55e); color: white;
  border: none; padding: 16px 36px; border-radius: 14px; font-weight: 800;
  font-size: 1.1rem; cursor: pointer; display: flex; align-items: center; gap: 10px;
  margin-top: 32px; float: right;
  &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 15px 30px rgba(22, 163, 74, 0.3); }
`;

const Row = styled.div`
  display: flex; gap: 16px;
  > div { flex: 1; }
  @media (max-width: 576px) { flex-direction: column; gap: 0; }
`;

/* 🔥 NEW STYLES FOR WAIVERS (AMNESTY) 🔥 */
const AddButton = styled.button`
  background: #3b82f6; color: white; border: none; padding: 14px 20px; border-radius: 12px;
  font-weight: 700; cursor: pointer; height: 50px; white-space: nowrap; margin-bottom: 20px;
  &:hover { background: #2563eb; }
  @media (max-width: 576px) { margin-top: 10px; width: 100%; }
`;

const WaiverWrap = styled.div` margin-top: 24px; padding-top: 20px; border-top: 1px dashed #e2e8f0; `;
const WaiverTitle = styled.div` font-size: 0.85rem; font-weight: 800; color: #64748b; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.05em; `;
const PillContainer = styled.div` display: flex; flex-wrap: wrap; gap: 8px; `;
const WaiverPill = styled.div`
  background: #f1f5f9; border: 1px solid #cbd5e1; color: #334155;
  padding: 6px 12px; border-radius: 999px; font-size: 0.85rem; font-weight: 700;
  display: flex; align-items: center; gap: 8px;
`;
const RemovePill = styled.button`
  background: none; border: none; color: #ef4444; font-weight: 900; cursor: pointer; padding: 0; display: flex; align-items: center; justify-content: center;
  &:hover { color: #b91c1c; transform: scale(1.1); }
`;

/* ================= MAIN COMPONENT ================= */
const ComplianceSettings = ({ user }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "success" });

  const [settings, setSettings] = useState({
    monthlyGoalDeadlineOffset: 0,
    weeklyGoalDay: 1,
    weeklyGoalTime: "10:00", 
    weeklyReportDay: 0,
    weeklyReportTime: "23:59", 
    appraisalDeadlineOffset: 1,
    dailyDeductionAmount: 0.25,
    waivedAppraisalMonths: [],
    waivedWeeklyGoals: [],
    waivedWeeklyReports: []
  });

  // State for adding new waivers
  const [waiverType, setWaiverType] = useState('weeklyGoal');
  const [waiverMonth, setWaiverMonth] = useState(getCurrentMonthName());
  const [waiverWeek, setWaiverWeek] = useState('Wk 1');

  // Reset week to Wk 1 when month changes to prevent invalid selections
  useEffect(() => { setWaiverWeek("Wk 1"); }, [waiverMonth]);

  useEffect(() => {
    fetchSettings();
  }, []);

  const triggerAlert = (message, type = "success") => {
    setAlert({ show: true, message, type });
    setTimeout(() => setAlert({ show: false, message: "", type: "" }), 5000);
  };

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const res = await api.get('/settings/compliance'); 
      if (res.data.success && res.data.data) {
        const dbData = res.data.data;
        
        const wGoalTime = `${String(dbData.weeklyGoalHour || 10).padStart(2, '0')}:00`;
        const wRepTime = `${String(dbData.weeklyReportHour || 23).padStart(2, '0')}:59`;

        setSettings({
          monthlyGoalDeadlineOffset: dbData.monthlyGoalDeadlineOffset ?? 0,
          weeklyGoalDay: dbData.weeklyGoalDay ?? 1,
          weeklyGoalTime: wGoalTime,
          weeklyReportDay: dbData.weeklyReportDay ?? 0,
          weeklyReportTime: wRepTime,
          appraisalDeadlineOffset: dbData.appraisalDeadlineOffset ?? 1,
          dailyDeductionAmount: dbData.dailyDeductionAmount ?? 0.25,
          waivedAppraisalMonths: dbData.waivedAppraisalMonths || [],
          waivedWeeklyGoals: dbData.waivedWeeklyGoals || [],
          waivedWeeklyReports: dbData.waivedWeeklyReports || []
        });
      }
    } catch (error) {
      triggerAlert("Failed to load settings. Check connection.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'time' ? value : Number(value)
    }));
  };

  // 🔥 ADD & REMOVE WAIVER HANDLERS
  const handleAddWaiver = () => {
    let waiverStr = waiverType === 'appraisal' ? waiverMonth : `${waiverMonth} - ${waiverWeek}`;
    
    if (waiverType === 'appraisal' && !settings.waivedAppraisalMonths.includes(waiverStr)) {
      setSettings(prev => ({ ...prev, waivedAppraisalMonths: [...prev.waivedAppraisalMonths, waiverStr] }));
    } else if (waiverType === 'weeklyGoal' && !settings.waivedWeeklyGoals.includes(waiverStr)) {
      setSettings(prev => ({ ...prev, waivedWeeklyGoals: [...prev.waivedWeeklyGoals, waiverStr] }));
    } else if (waiverType === 'weeklyReport' && !settings.waivedWeeklyReports.includes(waiverStr)) {
      setSettings(prev => ({ ...prev, waivedWeeklyReports: [...prev.waivedWeeklyReports, waiverStr] }));
    }
  };

  const handleRemoveWaiver = (type, str) => {
    if (type === 'appraisal') {
      setSettings(prev => ({ ...prev, waivedAppraisalMonths: prev.waivedAppraisalMonths.filter(x => x !== str) }));
    } else if (type === 'weeklyGoal') {
      setSettings(prev => ({ ...prev, waivedWeeklyGoals: prev.waivedWeeklyGoals.filter(x => x !== str) }));
    } else if (type === 'weeklyReport') {
      setSettings(prev => ({ ...prev, waivedWeeklyReports: prev.waivedWeeklyReports.filter(x => x !== str) }));
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      
      const payload = {
        monthlyGoalDeadlineOffset: settings.monthlyGoalDeadlineOffset,
        weeklyGoalDay: settings.weeklyGoalDay,
        weeklyGoalHour: parseInt(settings.weeklyGoalTime.split(':')[0], 10), 
        weeklyReportDay: settings.weeklyReportDay,
        weeklyReportHour: parseInt(settings.weeklyReportTime.split(':')[0], 10), 
        appraisalDeadlineOffset: settings.appraisalDeadlineOffset,
        dailyDeductionAmount: settings.dailyDeductionAmount,
        waivedAppraisalMonths: settings.waivedAppraisalMonths,
        waivedWeeklyGoals: settings.waivedWeeklyGoals,
        waivedWeeklyReports: settings.waivedWeeklyReports
      };

      await api.put('/settings/compliance', payload);
      triggerAlert("Global compliance settings updated successfully.");
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      triggerAlert(error.response?.data?.message || "Failed to save settings.", "error");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <AppContainer><PageWrapper><FaSync className="fa-spin" size={40} color="#3b82f6" /></PageWrapper></AppContainer>;

  return (
    <AppContainer>
      <NavBarSuper user={user} />
      <PageWrapper>
        <BackButton onClick={() => navigate('/super-admin/dashboard')}>← Back to Dashboard</BackButton>

        <HeroCard>
          <HeroTitle>System Compliance Rules</HeroTitle>
          <HeroText>
            Set the official system deadlines. These rules automatically update the calendar every month so you never have to change them manually.
          </HeroText>
        </HeroCard>

        {alert.show && (
          <AlertToast $type={alert.type}>
            {alert.type === 'error' ? <FaExclamationCircle size={20} /> : <FaCheckCircle size={20} />}
            {alert.message}
          </AlertToast>
        )}

        <InfoBox>
          <FaInfoCircle size={24} style={{ flexShrink: 0, marginTop: 2 }} />
          <div>
            <strong>Why don't we use a standard Calendar?</strong><br />
            If you picked "May 31st" from a calendar, you would have to log in and change it to "June 30th" next month. By selecting <em>"The Exact Last Day of the Month"</em>, the system automatically adapts to months with 28, 30, or 31 days forever.
          </div>
        </InfoBox>

        <SectionGrid>
          {/* --- WEEKLY DEADLINES --- */}
          <SettingsCard>
            <CardTitle>📅 Weekly Rhythm (Clock)</CardTitle>
            <CardDesc>Choose the day and exact time staff must submit their weekly tasks.</CardDesc>

            <Row>
              <FormGroup>
                <Label>Weekly Goal Deadline</Label>
                <Select name="weeklyGoalDay" value={settings.weeklyGoalDay} onChange={handleInputChange}>
                  {DAYS_OF_WEEK.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                </Select>
              </FormGroup>
              <FormGroup>
                <Label>Goal Time</Label>
                <Input type="time" name="weeklyGoalTime" value={settings.weeklyGoalTime} onChange={handleInputChange} />
              </FormGroup>
            </Row>

            <Row>
              <FormGroup>
                <Label>Weekly Report Deadline</Label>
                <Select name="weeklyReportDay" value={settings.weeklyReportDay} onChange={handleInputChange}>
                  {DAYS_OF_WEEK.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                </Select>
              </FormGroup>
              <FormGroup>
                <Label>Report Time</Label>
                <Input type="time" name="weeklyReportTime" value={settings.weeklyReportTime} onChange={handleInputChange} />
              </FormGroup>
            </Row>
          </SettingsCard>

          {/* --- MONTHLY DEADLINES --- */}
          <SettingsCard>
            <CardTitle>🗓️ Monthly & Appraisal Deadlines</CardTitle>
            <CardDesc>Select when the major monthly submissions are due.</CardDesc>

            <FormGroup>
              <Label>When are Monthly Goals due?</Label>
              <Select name="monthlyGoalDeadlineOffset" value={settings.monthlyGoalDeadlineOffset} onChange={handleInputChange}>
                {MONTHLY_RULES.map(rule => <option key={rule.value} value={rule.value}>{rule.label}</option>)}
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>When is the Appraisal Form due?</Label>
              <Select name="appraisalDeadlineOffset" value={settings.appraisalDeadlineOffset} onChange={handleInputChange}>
                {MONTHLY_RULES.map(rule => <option key={rule.value} value={rule.value}>{rule.label}</option>)}
              </Select>
            </FormGroup>
          </SettingsCard>

          {/* --- PENALTIES & CUTOFFS --- */}
          <SettingsCard style={{ gridColumn: '1 / -1' }}>
            <CardTitle>⚠️ Infinite Penalties</CardTitle>
            <CardDesc>If staff miss the exact times set above, how should the system penalize them?</CardDesc>

            <SectionGrid>
              <FormGroup style={{ marginBottom: 0 }}>
                <Label>Daily Point Deduction (Score out of 5.0)</Label>
                <Input 
                  type="number" step="0.05" min="0" max="5"
                  name="dailyDeductionAmount" 
                  value={settings.dailyDeductionAmount} 
                  onChange={handleInputChange} 
                />
                <HelperText>
                  The exact points subtracted for every 24 hours a submission is late. Example: <strong>0.25</strong>.<br/><br/>
                  <strong style={{color: '#dc2626'}}>Note:</strong> Deductions are infinite. If a user never logs an achievement for a goal, their score will continue dropping into negative numbers every single day until the end of time.
                </HelperText>
              </FormGroup>
            </SectionGrid>
          </SettingsCard>

          {/* 🔥 NEW: PENALTY WAIVERS (AMNESTY) 🔥 */}
          <SettingsCard style={{ gridColumn: '1 / -1', borderColor: '#bfdbfe', background: '#f8fafc' }}>
            <CardTitle>🛡️ Penalty Waivers</CardTitle>
            <CardDesc>Select specific weeks or months to completely ignore late deductions for specific submission types.</CardDesc>

            <Row style={{ alignItems: 'flex-end' }}>
              <FormGroup style={{ marginBottom: '20px' }}>
                <Label>Category</Label>
                <Select value={waiverType} onChange={(e) => setWaiverType(e.target.value)}>
                  <option value="weeklyGoal">Weekly Goals</option>
                  <option value="weeklyReport">Weekly Reports</option>
                  <option value="appraisal">Monthly Appraisals</option>
                </Select>
              </FormGroup>

              <FormGroup style={{ marginBottom: '20px' }}>
                <Label>Month</Label>
                <Select value={waiverMonth} onChange={(e) => setWaiverMonth(e.target.value)}>
                  {generateMonthOptions().map(m => <option key={m} value={m}>{m}</option>)}
                </Select>
              </FormGroup>

              {waiverType !== 'appraisal' && (
                <FormGroup style={{ marginBottom: '20px' }}>
                  <Label>Week</Label>
                  <Select value={waiverWeek} onChange={(e) => setWaiverWeek(e.target.value)}>
                    {generateWeekLabels(waiverMonth).map(w => <option key={w} value={w}>{w}</option>)}
                  </Select>
                </FormGroup>
              )}

              <AddButton onClick={handleAddWaiver}>+ Add Exemption</AddButton>
            </Row>

            <WaiverWrap>
              <WaiverTitle>Weekly Goal Exemptions</WaiverTitle>
              {settings.waivedWeeklyGoals.length === 0 ? <HelperText style={{marginTop:0, marginBottom:16}}>No exemptions active.</HelperText> : (
                <PillContainer style={{ marginBottom: 16 }}>
                  {settings.waivedWeeklyGoals.map(str => (
                    <WaiverPill key={str}>{str} <RemovePill onClick={() => handleRemoveWaiver('weeklyGoal', str)}><FaTimes /></RemovePill></WaiverPill>
                  ))}
                </PillContainer>
              )}

              <WaiverTitle>Weekly Report Exemptions</WaiverTitle>
              {settings.waivedWeeklyReports.length === 0 ? <HelperText style={{marginTop:0, marginBottom:16}}>No exemptions active.</HelperText> : (
                <PillContainer style={{ marginBottom: 16 }}>
                  {settings.waivedWeeklyReports.map(str => (
                    <WaiverPill key={str}>{str} <RemovePill onClick={() => handleRemoveWaiver('weeklyReport', str)}><FaTimes /></RemovePill></WaiverPill>
                  ))}
                </PillContainer>
              )}

              <WaiverTitle>Appraisal Exemptions</WaiverTitle>
              {settings.waivedAppraisalMonths.length === 0 ? <HelperText style={{marginTop:0}}>No exemptions active.</HelperText> : (
                <PillContainer>
                  {settings.waivedAppraisalMonths.map(str => (
                    <WaiverPill key={str}>{str} <RemovePill onClick={() => handleRemoveWaiver('appraisal', str)}><FaTimes /></RemovePill></WaiverPill>
                  ))}
                </PillContainer>
              )}
            </WaiverWrap>
          </SettingsCard>

        </SectionGrid>

        <div style={{ clear: 'both' }}>
          <SaveButton onClick={handleSave} disabled={saving}>
            {saving ? <FaSync className="fa-spin" /> : <FaSave />}
            {saving ? "Saving..." : "Save"}
          </SaveButton>
        </div>

      </PageWrapper>
      <Footer />
    </AppContainer>
  );
};

export default ComplianceSettings;